"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ranks = exports.files = exports.colors = void 0;
exports.colors = ['white', 'black'];
exports.files = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
exports.ranks = ['1', '2', '3', '4', '5', '6', '7', '8'];
//# sourceMappingURL=types.js.map